import React from 'react';
import { Engagement } from '../../types';
import Label from '../Label';

const EngagementStatusCell = ({
  engagement
}: { engagement: Engagement }) => (engagement.archivedDatetime
  ? <Label color="error">Archived</Label> : <Label color="success">Active</Label>);

export default EngagementStatusCell;
